import type { ZoomBucket } from '../redux/reducer';

export const DEFAULT_DESKTOP_REGULAR_PINS: Record<ZoomBucket, number | undefined> = {
  4: 25,
  6: 25,
  8: 25,
  12: 25,
  14: 30,
  23: undefined
};

export const DEFAULT_MOBILE_REGULAR_PINS: Record<ZoomBucket, number | undefined> = {
  4: 12,
  6: 12,
  8: 12,
  12: 12,
  14: 15,
  23: undefined
};

export const DEFAULT_DESKTOP_COLLAPSED_PINS: Record<ZoomBucket, number> = {
  4: 200,
  6: 200,
  8: 200,
  12: 200,
  14: 200,
  23: 0 // no collapsed pins when zoomed all the way in
};

export const DEFAULT_MOBILE_COLLAPSED_PINS: Record<ZoomBucket, number> = {
  4: 100,
  6: 100,
  8: 100,
  12: 100,
  14: 100,
  23: 0 // no collapsed pins when zoomed all the way in
};

export const ZOOM_BUCKETS: ZoomBucket[] = [4, 6, 8, 12, 14, 23];

// An unset zoom means the map hasn't reported a real position yet (before its first moveend), not that
// it's zoomed all the way in. Falling through to bucket 23 there would lift the pin cap and expand
// every pin for that first paint, which the next idle pass would immediately collapse back down.
const getZoomBucketFromZoom = (zoom?: number): ZoomBucket => {
  if (zoom === undefined) {
    return ZOOM_BUCKETS[0];
  }
  if (zoom <= 4) {
    return 4;
  }
  if (zoom <= 6) {
    return 6;
  }
  if (zoom <= 8) {
    return 8;
  }
  if (zoom <= 12) {
    return 12;
  }
  if (zoom <= 14) {
    return 14;
  }
  return 23;
};

const pinZoomPopularityMap = (
  zoom?: number
): {
  maxDesktopRegularPins?: number;
  maxMobileRegularPins?: number;
  maxTotalDesktopPins?: number;
  maxTotalMobilePins?: number;
} => {
  const zoomBucket = getZoomBucketFromZoom(zoom);

  const desktopRegular = DEFAULT_DESKTOP_REGULAR_PINS[zoomBucket];
  const mobileRegular = DEFAULT_MOBILE_REGULAR_PINS[zoomBucket];
  const desktopCollapsed = DEFAULT_DESKTOP_COLLAPSED_PINS[zoomBucket];
  const mobileCollapsed = DEFAULT_MOBILE_COLLAPSED_PINS[zoomBucket];

  return {
    maxDesktopRegularPins: desktopRegular,
    maxMobileRegularPins: mobileRegular,
    maxTotalDesktopPins: desktopRegular ? desktopRegular + desktopCollapsed : undefined,
    maxTotalMobilePins: mobileRegular ? mobileRegular + mobileCollapsed : undefined
  };
};

export default pinZoomPopularityMap;
